export const FLEXSHIP_MAX_AMOUNT = 30000;

export function isFlexShipEnabled(value) {
  if (value === true || value === 1) return true;
  if (typeof value === "string") return value.trim().toLowerCase() === "true";
  return false;
}

export function parseFlexShipAmount(value) {
  if (value === null || value === undefined) return { empty: true };
  let raw = String(value).trim();
  if (raw.endsWith(".")) raw = raw.slice(0, -1);
  if (raw === "") return { empty: true };
  if (!/^\d+(?:\.\d{1,2})?$/.test(raw)) return { invalid: true };
  const amount = Number(raw);
  if (!Number.isFinite(amount)) return { invalid: true };
  return { amount };
}

/** Empty stored amount stays blank so turning FlexShip on does not look pre-filled with 0. */
export function formatFlexShipAmountInput(amount) {
  const parsed = parseFlexShipAmount(amount);
  if (parsed.empty || parsed.invalid || !parsed.amount) return "";
  return String(parsed.amount);
}

/**
 * Build the PUT body. Omitting the amount keeps the stored amount.
 * Omitting the toggle is not used here: the form always sends the toggle.
 */
export function buildFlexShipPayload(enabled, amountInput) {
  const on = isFlexShipEnabled(enabled);
  const parsed = parseFlexShipAmount(amountInput);

  if (!parsed.empty && (parsed.invalid || parsed.amount > FLEXSHIP_MAX_AMOUNT)) {
    return { error: "invalid" };
  }

  if (on && (parsed.empty || parsed.amount <= 0)) {
    return { error: "required" };
  }

  const payload = { flexShipEnabled: on };
  if (!parsed.empty) payload.flexShipCollectionAmount = parsed.amount;
  return { payload };
}
